import { Routes } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';
import { AppBlankComponent } from './layouts/blank/blank.component';
import { AuthGuard } from './auth/guards/auth.guard';

export const AppRoutes: Routes = [
    {
        path: '',
        redirectTo: '/dms/dashboard',
        pathMatch: 'full'
    },
    {
        path: '',
        component: FullComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'dms',
                loadChildren: () => import('./dms/dms.module').then(m => m.DmsModule)
            }
        ]
    },
    {
        path: '',
        component: AppBlankComponent,
        children: [
            {
                path: 'auth',
                loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
            },
            {
                path: 'verify',
                loadChildren: () => import('./verification/verification.module').then(m => m.VerificationModule)
            },
            {
                path: 'verify-document',
                loadChildren: () => import('./verification-portal/verification-portal.module').then(m => m.VerificationPortalModule)
            }
        ]
    },
    {
        path: '**',
        redirectTo: '/auth/login'
    }
];
